import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

export class SessionServiceAjs {
  static $inject = [
    '$http',
    '$location',
    '$cookies',
    '$translate',
    'LocalStoreService',
    'amMoment',
  ];

  apiUrl = environment.apiEndpoint + 'sessions';

  constructor(
    private $http,
    private $location,
    private $cookies,
    private $translate,
    private LocalStoreService,
    private amMoment
  ) {}

  // Get default account company - TODO: willy -validate if the user has access to that company, otherwise select order by name
  getDefaultAccountCompany = () => {
    var accountCompanies = this.getAccountCompanies();
    for (var i = 0; i < accountCompanies.length; i++) {
      if (accountCompanies[i].is_default || accountCompanies.length === 1) {
        return accountCompanies[i];
      }
    }
  };

  login(params) {
    return this.$http.post(this.apiUrl, params).then(
      (response) => {
        this.setCurrentUser('cu', response.data);

        if (response.data.user_info && !response.data.user_info.sd) {
          // Only AccountAdmins
          // TODO: willy - what about if the user does not have permissions to access the default account??
          var company = this.getDefaultAccountCompany();
          this.setSelectedAccountCompany(company);
        }

        return {
          status: true,
        };
      },
      (response) => {
        return {
          status: false,
          response: response.data,
        };
      }
    );
  }

  logout() {
    return this.$http.delete(this.apiUrl + '/0').then(
      () => {
        // The backend doesn't care about logouts, delete the token and you're good to go. ??
        this.LocalStoreService.unset('cu');

        this.LocalStoreService.unset('selectedAccountCompany');
        // this.$cookies.putObject('selectedAccountCompany', null);

        this.$location.path('/login'); // { reload: true }
      },
      () => {}
    );
  }

  // if validateSession === true it will check the session in the server
  // if not just check the user in the local
  isLoggedIn() {
    // validateSession
    if (this.currentUser()) {
      return true;
    }

    return false;
  }

  currentUser() {
    var data = this.getCurrentUser();

    if (data && data.user_info) {
      return data.user_info;
    }

    return null;
  }

  getCurrentUser() {
    return JSON.parse(this.LocalStoreService.get('cu'));
    // return angular.fromJson(this.LocalStoreService.get('cu'));
  }

  hideWarningMessage(component, setting) {
    this.LocalStoreService.set(component, JSON.stringify(setting));
  }

  isWarningMessageHidden(component) {
    return JSON.parse(this.LocalStoreService.get(component));
    // return angular.fromJson(this.LocalStoreService.get(component));
  }

  setCurrentUser(key, val) {
    // TODO: We can re-adjust or object = user = { key: value }
    this.LocalStoreService.set(key, JSON.stringify(val));
  }

  getAccountCompanies() {
    var data = JSON.parse(this.LocalStoreService.get('cu'));
    // var data = angular.fromJson(this.LocalStoreService.get('cu'));

    if (!data) {
      return false;
    }

    var currentUser = data.user_info;
    var accountCompanies = currentUser.companies;

    if (!accountCompanies) {
      return false;
    }

    return accountCompanies;
  }

  getSelectedAccountCompany() {
    // if (this.$cookies.getObject('selectedAccountCompany')) {
    // return this.$cookies.getObject('selectedAccountCompany');

    if (this.LocalStoreService.get('selectedAccountCompany')) {
      return JSON.parse(this.LocalStoreService.get('selectedAccountCompany'));
    } else {
      // TODO: willy - what about if the user does not have permissions to access the default account??
      var company = this.getDefaultAccountCompany();

      this.setSelectedAccountCompany(company);

      return this.setCompanyObject(company);
    }
  }

  setSelectedAccountCompany(company) {
    company = this.setCompanyObject(company);

    this.LocalStoreService.set('selectedAccountCompany', JSON.stringify(company));

    // if (setObject){ // TODO: willy check as company selecter has setObjet false
    // }

    // return this.$cookies.putObject('selectedAccountCompany', company);
  }

  // Get default account company website
  getDefaultAccountCompanyWebsite() {
    var accountCompanyWebsites = this.getSelectedAccountCompany().websites;

    for (var i = 0; i < accountCompanyWebsites.length; i++) {
      if (accountCompanyWebsites[i].is_default || accountCompanyWebsites.length === 1) {
        return accountCompanyWebsites[i];
      }
    }
  }

  getSelectedAccountCompanyWebsite() {
    return (
      this.$cookies.getObject('selectedAccountCompanyWebsite') ||
      this.getDefaultAccountCompanyWebsite()
    );
  }

  // setSelectedAccountCompanyWebsite(website) {
  //   return this.$cookies.putObject('selectedAccountCompanyWebsite', website);
  // }

  // Store only these fields to localStorage
  setCompanyObject(company) {
    if (!company) {
      return false;
    }

    // To avoid possibly not set or overflowed because it was too large
    var item = {
      id: company.id,
      commercial_name: company.commercial_name,
      logo: company.logo,
      is_default: company.is_default,
      account_id: company.account_id,
      currency_id: company.currency_id,
      country: {
        code: company.country.code,
        enable_states: company.country.enable_states,
        name: company.country.name,
        phone_code: company.country.phone_code,
      },
      websites: company.websites,
      atv_cr_enabled: null,
    };

    if (company.company_integration) {
      item.atv_cr_enabled = company.company_integration.atv_cr_enabled;
    }

    return item;
  }

  // Leave it here as if you use the service call this service again
  /* findCompanyInCompanies(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }

    return null;
  } */

  getUserLanguage() {
    if (this.LocalStoreService.get('timUserLang')) {
      return JSON.parse(this.LocalStoreService.get('timUserLang')) || {};
    }

    // return this.$cookies.getObject('timUserLang') || {};
  }

  setUserLanguage(language) {
    this.setCurrentTranslationLanguage(language.code);

    this.LocalStoreService.set('timUserLang', JSON.stringify(language));

    // return this.$cookies.putObject('timUserLang', language);
  }

  setCurrentTranslationLanguage(code) {
    this.$translate.use(code);
    this.amMoment.changeLocale(code);
  }
}
